import CheckboxInput from './CheckboxInput';

export * from './CheckboxInput';

export default CheckboxInput;
